// extracted by mini-css-extract-plugin
export default {"root":"y7uEwMpWMNFkWjAmuvFV","placeHolderShimmer":"n_pHOdHeVNot_a0dIPcz"};